





















import Vue from "vue"
import { Component } from "vue-property-decorator"
import EventCard from "@/components/EventCard.vue"
import axios from "axios"
import { GenericResponse } from "@/data/models/response"
import AddIcon from "vue-ionicons/dist/md-add.vue"

@Component({
    components: {EventCard, AddIcon},
})
export default class About extends Vue {
    events: EventModel[] | null = null

    mounted() {
        axios.get(`${process.env.VUE_APP_BASE_URL}/cms/events`).then(
            response => {
                let data = response.data as GenericResponse<EventModel[]>
                if (response.status == 200 && data.success) {
                    this.events = data.data!
                }
            },
        )
    }

    onDelete(event: EventModel) {
        if (!confirm("Event wirklich löschen?")) {
            return
        }

        axios.delete(`${process.env.VUE_APP_BASE_URL}/cms/content/${event.id}`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("jwt")
            },
        }).then(
            response => {
                this.events = (this.events || []).filter((e) => e.id !== event.id)
            },
            e => {
            }
        )
    }

    async addEvent() {
        await this.$router.push({name: "add-event"})
    }

    get isLoggedIn(): boolean {
        return localStorage.getItem("jwt") != null
    }
}
